import '../css/app.css';
import { createApp } from 'vue';
import router from './router';
import App from './App.vue';
import './auth';
import { installPreload, syncPage } from './page';

installPreload();

let first = true;
router.afterEach((to) => {
    if (first) { first = false; return; } // first load: server metadata is already in the HTML
    syncPage(to.path);
});

// Mount only once the route component is resolved, so the server-rendered
// HTML stays on screen until Vue can replace it in one step.
const app = createApp(App).use(router);
router.isReady().then(() => app.mount('#app'));
